export enum BuyCoinCodeTypeEnum {
  DISCOUNT = 'DISCOUNT',
  COIN = 'COIN',
}

export const BuyCoinCodeTypeValue = {
  [BuyCoinCodeTypeEnum.DISCOUNT]: 'รับส่วนลด',
  [BuyCoinCodeTypeEnum.COIN]: 'รับเพิ่ม',
}
